// Grid
import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const Wrapper = styled.div`
  display: grid;
  grid-template-columns: 100%;
  grid-column-gap: 2%;
  @media (min-width:1060px) {
    grid-template-columns: 32% auto 32%;
  }
`;

function Grid({ className = "", ...props }) {
  const classNames = [ "common-grid uk-position-relative", className ].join(" ");
  return(
    <Wrapper className={ classNames } { ...props } >
      {props.children}
    </Wrapper>
  );
}

Grid.propTypes = {
  children: PropTypes.node,
  text: PropTypes.string,
  className: PropTypes.any
};

export default Grid;



// WEBPACK FOOTER //
// ./src/features/common/Grid.js